import React from 'react';
import {
  identity,
  api,
  recaptchaKey,
  setAuthToken,
  getAccountList,
  generateToken,
  generatePromotionToken,
  availableUserName,
  getRestrictedGames,
  verifyEmail,
  confirmVerifyEmail,
  acquirePI,
  acquireParentPI,
  createAccount,
  promoteAccount
} from './api';
import { footer, contentFooter } from './comps/Footer';
import { getInitialTheme, CONFIG_THEME, getInitialState } from './api/config';
import queryString from 'query-string';
import Flow from './FlowManager/flow';

const AppContext = React.createContext();
const { Provider, Consumer: AppContextConsumner } = AppContext;

const initialState = {
  theme: {
    theme: 'riot'
  },
  footer: '',
  contentFooter: '',
  step: {
    component: null,
    page: 0,
    pageCount: 0
  },
  pageTitle: '라이엇 계정 생성',
  urlParams: window.location.search && queryString.parse(window.location.search), // Todo: Split context into another context
  signupType: 'DEFAULT',
  flows: [],
  transactionToken: '',
  sessionToken: '',

  moreAccountsAllowed: true,
  gameRestricted: false,
  restrictedGames: [],
  existingAccounts: [],

  username: '',
  age: '19',
  realName: '',
  birthDate: '00000000',
  govtId: '',
  playerAuthInfo: '',
  password: '',

  email: '',
  emailVerified: false,
  marketingAgreement: {
    email: false
  },

  parentEmail: '',
  parentAuthInfo: '',

  hasError: false,
  shouldReset: false,
  errorHeader: '',
  errorDetail: '',
  backToComponent: '',
  backToPage: 0,

  identity,
  recaptchaKey
};

class AppContextProvider extends React.Component {
  constructor(props) {
    super(props);

    const localState = JSON.parse(sessionStorage.getItem('localState'));
    this.state = localState || initialState;

    this.state.footer = footer;
    this.state.contentFooter = contentFooter;

    if (this.state.theme.theme === 'riot') {
      this.state.theme = {
        theme: getInitialTheme(this.state.urlParams, CONFIG_THEME)
      };
    }

    if (localState && localState.transactionToken) {
      setAuthToken(localState.transactionToken);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.flows || prevState.flows.length === 0) {
      // console.warn('NO FLOWS FOUND!');
      return getInitialState(true, prevState.urlParams.session_token);
    }

    return null;
  }

  static setInitialState(isAdult = true, token = '') {
    const signupType = token ? 'PROMOTION' : 'DEFAULT';
    const pageTitle = token ? '라이엇 계정으로 업그레이드' : '라이엇 계정 생성';
    const sessionToken = token;
    const flows = isAdult ? Flow[`${signupType}`].NORMAL : Flow[`${signupType}`].MINOR;

    return {
      flows,
      signupType,
      sessionToken,
      pageTitle,
      step: {
        component: flows[0].curr,
        page: 0,
        pageCount: flows.filter((flow) => flow.nextIncreaseCount).length + 1
      }
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.transactionToken !== this.state.transactionToken) {
      setAuthToken(this.state.transactionToken);
    }
  }

  setFlowState = async (isMinor = false) => {
    const { signupType, step } = this.state;
    const flows = isMinor ? Flow[`${signupType}`].MINOR : Flow[`${signupType}`].NORMAL;

    await this.setData({
      step: {
        ...step,
        pageCount: flows.filter((flow) => flow.nextIncreaseCount).length + 1
      },
      flows
    });
  };

  actions = {
    api,
    generateToken: (payload) => generateToken(payload),
    generatePromotionToken: (payload) => generatePromotionToken(payload),
    getAccountList: () => getAccountList(this.state.govtId),
    availableUserName: (name) => availableUserName(name),
    getRestrictedGames: (authToken) => getRestrictedGames(authToken),
    verifyEmail: (payload) => verifyEmail(payload),
    confirmVerifyEmail: (payload) => confirmVerifyEmail(payload),
    acquirePI: (selfAuthResponseToken) => acquirePI(selfAuthResponseToken),
    acquireParentPI: (authToken) => acquireParentPI(this.state.playerAuthInfo, authToken),
    createAccount: (payload) => createAccount(payload),
    promoteAccount: (payload) => promoteAccount(payload),
    stepTo: (data) => {
      const newData = { step: { ...this.state.step, ...data } };
      const reducedData = this.reducer(this.state, newData);

      this.setState({
        ...reducedData
      });
    },
    setData: (data) => this.setData(data),
    setFlow: this.setFlowState,
    resetState: (exceptionData) => this.setDataReset(exceptionData)
  };

  setData = (data) => {
    const reducedData = this.reducer(this.state, data);
    new Promise((resolve) => this.setState({ ...reducedData }, resolve));
  };

  setDataReset = (exceptionData) => {
    const reducedData = this.reducer(initialState, exceptionData);
    new Promise((resolve) => this.setState({ ...reducedData }, resolve));
  };

  reducer = (state, newState) => {
    if (!newState) {
      // Reset state && localState
      sessionStorage.removeItem('localState');
      console.warn('RESET STATE');
      return initialState;
    }

    // console.warn('reducer', { state }, { newState });
    const reducedState = { ...state, ...newState };
    sessionStorage.setItem('localState', JSON.stringify(reducedState));

    return reducedState;
  };

  render() {
    const { state, actions } = this;

    return <Provider value={{ state, actions }}>{this.props.children}</Provider>;
  }
}

const useAppContext = (WrappedComponent) =>
  function UseAppContext(props) {
    return (
      <AppContextConsumner>
        {({ state, actions }) => <WrappedComponent {...props} state={state} actions={actions} />}
      </AppContextConsumner>
    );
  };

export { AppContextProvider, AppContextConsumner, useAppContext };
export default AppContext;
